module.exports = __webpack_public_path__ + "img/napcologo.fc5b5df6.png";